
import React from 'react';
import { Button } from '@/components/ui/button';
import { Send, RefreshCw } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

interface ManagementHeaderProps {
  onRefresh: () => void;
}

export const ManagementHeader: React.FC<ManagementHeaderProps> = ({ onRefresh }) => {
  const { t } = useTranslation();
  
  return (
    <header className="py-4 mb-8">
      <div className="flex justify-between items-center">
        <div>
          <h2 className="text-2xl font-semibold">{t('interviewManagement.title')}</h2>
          <p className="text-gray-600 mt-2">
            {t('interviewManagement.description')}
          </p>
        </div>
        <div className="flex gap-2">
          <Button 
            variant="outline" 
            onClick={onRefresh}
            className="flex items-center gap-2"
          >
            <RefreshCw className="h-4 w-4" />
            {t('interviewManagement.refresh')}
          </Button>
          <Link to="/feeder">
            <Button variant="outline" className="flex items-center gap-2">
              <Send className="h-4 w-4" />
              {t('interviewManagement.goToQueue')}
            </Button>
          </Link>
        </div>
      </div>
    </header>
  );
};
